import { render } from "./NavCategoriesLink.vue?vue&type=template&id=1315776a"
import script from "./NavCategoriesLink.vue?vue&type=script&lang=js"
export * from "./NavCategoriesLink.vue?vue&type=script&lang=js"

import "./NavCategoriesLink.vue?vue&type=style&index=0&id=1315776a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__